// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.store/css-loader@3.6.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".item-style[data-v-22d797e3]{padding:10px 0}", ""]);
// Exports
module.exports = exports;
